import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-compra-online',
  template: `
  <router-outlet></router-outlet>
`,
})
export class CompraOnlineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
 
}
